import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { api } from "api/api";
import { useToast } from "contexts/toast/toast.context";

export default function AxiosInterceptor() {
  const [isSet, setIsSet] = useState(false);
  const navigate = useNavigate();
  const { addFailureToast } = useToast();

  useEffect(() => {

    const resInterceptor = response => {
      return response;
    }

    const errInterceptor = error => {

      if (error.response) {
        if (error.response.status === 401) {
          localStorage.removeItem("authToken");
          navigate("/login");
          addFailureToast("Token nieważny");
        }
      }

      return Promise.reject(error);
    };

    const interceptor = api.interceptors.response.use(resInterceptor, errInterceptor);

    setIsSet(true);

    return () => api.interceptors.response.eject(interceptor);

  }, [])

  return isSet;
}